import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,_vm._b({ref:"tooltip",attrs:{"open-delay":_vm.openDelay},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({ref:"content"},on),[_vm._t("default")],2)]}}],null,true),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},'v-tooltip',_vm.tdTooltipPosition,false),[_c('div',[_vm._t("tooltipValue")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }